import React, { useState, useEffect, useContext } from "react";
import SubHeader from "./SubHeader";
import { FormGroup, Col, Label, Input, Form, Row, NavLink, ListInlineItem, Dropdown, DropdownToggle, } from "reactstrap";
import { FaChevronDown, FaChevronRight, FaEdit,FaRedo } from "react-icons/fa";
import { BsChevronRight } from "react-icons/bs";
import axios from "../../api/axios";
import { GlobalContext } from "../../App";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { MDBTable, MDBTableHead, MDBTableBody } from "mdb-react-ui-kit";
import projectPlaceholderImg from "../../assets/images/no-projects.png";
import HoverTooltip from "../global/Tooltip";
import TopHeader from "./TopHeader";
import { InfinitySpin } from "react-loader-spinner";
function ArchiveProjects() {
  const navigate = useNavigate();
  const currentDate = new Date().toISOString().substr(0, 10);
  const body = document.body;
  const mainPanel = document.querySelector(".main-panel");
  const maskBgOverlay = document.createElement("div");
  maskBgOverlay.id = "maskBgOverlay";
  maskBgOverlay.className = "maskBgOverlay";
  const location = useLocation();
  const { pathname } = location;
  const { rolexModuleData, user_id, serialSequence, roles, userProfile } =
    useContext(GlobalContext);   
const isSpecialAccess = rolexModuleData?.find( (data) => pathname === data?.description && data?.special === 1 )|| roles?.find((data1) => data1?.role_id === 1001) ? true : false;

  // ................. expand collaspe product table...............................//
  const [productisOpen1, productsetIsOpen1] = useState(1);
  const [taskList, setTaskList] = useState([]);
  const [tempTaskList, setTempTaskList] = useState([]);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const [modal, setModal] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [taskData, setTaskData] = useState({
    projectTitle: [],
    milestoneTitle: [],
    taskTitle: "",
    taskDesc: "",
    taskStatus: { value: "Completed", label: "Completed" },
    TaskPrirority: { value: "High", label: "High" },
    TaskCompletionDate: "",
    taskStartDate: "",
    taskEndDate: "",
    taskOwner: [],
    updateId: null,
    taskCompletionPercentage: { value: "0", label: "0" },
  });
  const [loading, setLoading] = useState(true);
  const [filterTask, setFilterTask] = useState({
    taskId: "",
    taskTitle: "",
    projectTitle:"",
    milestoneTitle:"",
    taskStartDate: "",
    taskEndDate: "",
    createdBy: "",
  });
  const [taskProjectList, setTaskProjectList] = useState([]);
  //................... End  expand collaspe product table..........................//

  // Handle Error
  const handleError = (error) => {
    setLoading(false);
    const statusCode = error.response ? error.response.status : null;
    let errorMessage = "An error occurred!";

    if (statusCode === 500) {
      errorMessage = "Internal Server Error!";
    } else if (statusCode === 404) {
      errorMessage = "Page Not Found!";
    }

    toast.error(errorMessage, {
      position: toast.POSITION.TOP_RIGHT,
      theme: "colored",
      autoClose: 2000,
    });
  };


  // -------------------------------------------------------- Get User Data --------------------------------------
  const getUserData = () => {
    setLoading(true);
    const UserListCriteria = isSpecialAccess ? "" : userProfile || ""; 
    axios.get(`/getUserData?UserListCriteria=${JSON?.stringify(UserListCriteria)}`).then((response, error) => {
        const userTaskList = response?.data?.[0]?.user_data
          ?.filter((item) => item?.user_id === user_id)?.[0]
          ?.user_x_task?.filter((data) => data?.task_access === 1 || data?.createdBy === user_id)
          ?.map((data) => data?.task_id);
        getTaskList(userTaskList);
        setLoading(false);
      })
      .catch(handleError);
  };
  // ------------------------------------------------------------- Get Task List ---------------------------------

  const getTaskList = (userTaskList) => {
    setLoading(true);
  
    axios.get("/getArchiveProjectList")
      .then((response) => {
        const taskData = response?.data?.[0]?.task_data;
        if (!taskData) {
          setLoading(false);
          return;
        }
  
        // Create a map to store unique projects and milestones
        const projectMap = new Map();
        const milestoneMap = new Map();
  
        const formattedTaskList = taskData
          ?.sort((a, b) => (a.updatedDate < b.updatedDate ? 1 : -1))
          ?.filter((data) => isSpecialAccess || data?.project_master?.[0]?.project_owner_id === user_id || parseInt(data?.createdBy) === user_id ? data : userTaskList?.includes(data?.task_id) )
          ?.map((task) => {
            const projectId = task?.project_master?.[0]?.project_id;
            const milestoneId = task?.milestone_master?.[0]?.milestone_id;
  
            // Add project to the map if not present
            if (projectId && !projectMap.has(projectId)) {
              projectMap.set(projectId, task.project_master[0]);
            }
  
            // Add milestone to the map if not present
            if (milestoneId && !milestoneMap.has(milestoneId)) {
              milestoneMap.set(milestoneId, task.milestone_master[0]);
            }
  
            return {
              ...task,
              project: projectMap.get(projectId),
              milestone: milestoneMap.get(milestoneId),
            };
          });
        const groupedTaskData = {};
        formattedTaskList?.forEach((task) => {
          const projectId = task?.project?.project_id;
          const milestoneId = task?.milestone?.milestone_id ;
          if (projectId || milestoneId) {
            const key = `${projectId}_${milestoneId}`;
  
            if (!groupedTaskData[key]) {
              groupedTaskData[key] = {
                projectTitle: task?.project?.project_title || "",
                projectId: projectId,
                milestoneTitle: task?.milestone?.milestone_title || "",
                milestoneId: milestoneId,
                taskData: [],
              };
            }
  
            groupedTaskData[key].taskData.push(task);
          }
        });
    
        // Convert the grouped task data object to an array
        const TaskProjectList = Object.values(groupedTaskData);
        setTaskProjectList(TaskProjectList);
        productsetIsOpen1(formattedTaskList?.[0]?.task_id);
        setTaskList(formattedTaskList);
        setTempTaskList(TaskProjectList);
        setLoading(false);
      })
      .catch(handleError);
  };

  // ----------------------------------------------------------- Handle Close ---------------------------------------
  const handleClose = () => {
    setModal(false);
    setIsFilter(false);
    setTaskData({
      projectTitle: [],
      milestoneTitle: [],
      taskTitle: "",
      taskDesc: "",
      taskStatus: { value: "Completed", label: "Completed",percentage:'100' },
      TaskPrirority: { value: "High", label: "High" },
      TaskCompletionDate: "",
      taskStartDate: "",
      taskEndDate: "",
      taskOwner: [],
      updateId: null,
      taskCompletionPercentage: { value: "0", label: "0" },
    });
    body.style.overflow = "";
    document.getElementById("maskBgOverlay").remove();
  };

  const toggleModal = () => {
    setIsFilter(false);
    setModal(!modal);
    body.style.overflow = "hidden";
    mainPanel.appendChild(maskBgOverlay);
  };

  const toggleFilter = () => {
    setIsFilter(true);
    setModal(!modal);
    body.style.overflow = "hidden";
    mainPanel.appendChild(maskBgOverlay);
  };

  // -------------------------------------------------------- Filter Task List --------------------------------------
  const filterTaskList = (clear) => {
    const filteredTasks = tempTaskList?.filter((data) => {
      return (
        (!filterTask?.projectTitle ||
          data?.projectTitle?.includes(filterTask.projectTitle)) &&
        (!filterTask?.milestoneTitle ||
          data?.milestoneTitle?.includes(filterTask.milestoneTitle)) 
          &&
        (!filterTask?.taskId ||
          data?.taskData?.some((item) =>
            item?.find(
              (task) =>
                task?.task_code?.includes(filterTask.taskId) ||
                task?.task_title?.includes(filterTask.taskId)
            )
          )) &&
        (!filterTask?.taskStartDate ||
          data?.taskData?.some((item) =>
            item?.find((task) =>
              task?.task_start_date?.includes(filterTask.taskStartDate)
            )
          )) &&
        (!filterTask?.taskEndDate ||
          data?.taskData?.some((item) =>
            item?.find((task) =>
              task?.task_end_date?.includes(filterTask.taskEndDate)
            )
          )) &&
        (!filterTask?.createdBy ||
          data?.taskData?.some((item) =>
            item?.find((task) => task?.created_user?.includes(filterTask.createdBy))
          ))
      );
    });
  
    setTaskProjectList(filteredTasks);
  
    if (clear) {
      handleClose();
    }
  };
  

  // ------------------------------------------------------- Clear Filter Field ------------------------------------------
  const ClearFilter = () => {
    setFilterTask({
      taskId: "",
      taskTitle: "",
      projectTitle:"",
      milestoneTitle: "",
      taskStartDate: "",
      taskEndDate: "",
      createdBy: "",
    });
    filterTaskList(false);
    setTaskProjectList(tempTaskList);
  };
  // ---------------------------------------------------------- Mantain Log History ------------------------------
  const postLogHistory = () => {
    const param = {
      user_id: user_id,
      module_name: "Task",
      operationPerformed: "navigate to task screen",
    };
    axios.post("/postLogHistory", param);
  };

  // -------------------------------------------------------- Use Effect -----------------------------------------
  useEffect(() => {
    getUserData();
    // postLogHistory();
  }, []);
  return loading ? (
    <div className="loader">
      <InfinitySpin width="200" color="#D81159" />
    </div>
  ) : (
    <>
      <TopHeader
        breadCrumb={
          <>
            <li className="nav-item">
              <a onClick={() => navigate("/home")} className="nav-link">
                Home <BsChevronRight />
              </a>
            </li>
            <li className="nav-item">
              <span> Archieve Tasks</span>
            </li>
          </>
        }
      />
      <SubHeader
        SubHeaderTitle="Status"
        ShowFilterIcon={true}
        openSidebar={modal}
        isFilter={isFilter}
        handleClose={handleClose}
        toggleModal={toggleModal}
        toggleFilter={toggleFilter}
        filterSubmit={filterTaskList}
        userStatus={
          <ListInlineItem>
            <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
              <DropdownToggle className="activeuser" caret>
              Completed
              </DropdownToggle>
            </Dropdown>
          </ListInlineItem>
        }
        SlideBarContent={
          <Form className="modelform">
            <FormGroup>
              <Row>
                <Col md={12}>
                  <div className="resetFilterOption">
                    <a onClick={ClearFilter}>Clear Filter</a>
                  </div>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="ProjectTitle">Level 0 Title</Label>
                    <Input
                      type="text"
                      id="ProjectTitle"
                      name="ProjectTitle"
                      value={filterTask?.projectTitle || ""}
                      onChange={(e) =>
                        setFilterTask({
                          ...filterTask,
                          projectTitle: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="MilestoneTitle">Level 1 Title</Label>
                    <Input
                      type="text"
                      id="MilestoneTitle"
                      name="MilestoneTitle"
                      value={filterTask?.milestoneTitle || ""}
                      onChange={(e) =>
                        setFilterTask({
                          ...filterTask,
                          milestoneTitle: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
               <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="taskId">Task ID/Title</Label>
                    <Input
                      type="text"
                      placeholder="Search by Task ID or Title"
                      id="taskId"
                      name="taskId"
                      value={filterTask?.taskId || ""}
                      onChange={(e) =>
                        setFilterTask({ ...filterTask, taskId: e.target.value })
                      }
                      disabled={
                        filterTask?.taskTitle?.length > 0 ? true : false
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="startDate">Start Date</Label>
                    <Input
                      type="date"
                      id="startDate"
                      name="startDate"
                      value={filterTask?.taskStartDate || ""}
                      onChange={(e) =>
                        setFilterTask({
                          ...filterTask,
                          taskStartDate: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="endDate">End Date</Label>
                    <Input
                      type="date"
                      id="endDate"
                      name="endDate"
                      value={filterTask?.taskEndDate || ""}
                      onChange={(e) =>
                        setFilterTask({
                          ...filterTask,
                          taskEndDate: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="userRole">Created By</Label>
                    <Input
                      type="text"
                      id="createdBy"
                      name="createdBy"
                      value={filterTask?.createdBy || ""}
                      onChange={(e) =>
                        setFilterTask({
                          ...filterTask,
                          createdBy: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col> 
              </Row>
            </FormGroup>
          </Form>
        }
      />
      <div id="tasks" className="contentInnerWrap">
        <div className="tasks-wrap">
          <div className="dropdown-wrap">
          {/* <div className="reloadData" style={{margin:10,color:"#199ec9" ,}}>
            <FaRedo onClick={getUserData} title="Refresh Data" size={20} />
          </div> */}
            {taskProjectList?.length > 0 ?
              (taskProjectList?.map((data) => (
                  <>
                    <div className="dropdown " onClick={()=> productsetIsOpen1(productisOpen1 === data?.taskData?.[0]?.task_id ? 0 : data?.taskData?.[0]?.task_id)}>
                        {productisOpen1 === data?.taskData?.[0]?.task_id ? (
                          <FaChevronDown />
                        ) : (
                          <FaChevronRight
                          />
                        )}
                        <span>
                          <a onClick={() => navigate(`/project-detail?param1=${btoa(data?.projectId)}`)}>
                            {data?.projectTitle}
                          </a>
                          {data?.milestoneTitle?.length > 0 && (
                            <a onClick={() => navigate(`/milestones?param1=${btoa( data?.projectId )}&?param2=${btoa(data?.milestoneId)}`)}>
                              <BsChevronRight />
                              {data?.milestoneTitle}
                            </a>
                          )}
                        </span>
                      </div>
                    <div className="product-table">
                      <div
                        className={
                          productisOpen1 === data?.taskData?.[0]?.task_id
                            ? "product-list  productlist-open"
                            : "product-list "
                        }
                      >
                        {data?.taskData?.length > 0 ? (
                          <MDBTable align="middle" className="projectTable">
                            <MDBTableHead>
                              <tr>
                                <th scope="col" style={{ minWidth: "420px" }}>
                                  Tasks
                                </th>
                                <th scope="col">Status</th>
                                <th
                                  scope="col"
                                  style={{
                                    minWidth: "220px",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  Team Members
                                </th>
                                <th scope="col">Task Completed</th>
                                <th scope="col">Duration</th>
                                <th scope="col">Start Date</th>
                                <th scope="col">End Date</th>
                                <th scope="col">Priority</th>
                                <th scope="col">Completion Date</th>
                                <th scope="col">Created On</th>
                                <th scope="col">Created By</th>
                                <th scope="col">Modified On</th>
                                <th scope="col">Modified By</th>
                              </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                              {data?.taskData?.map((data1) => (
                                  <tr className="table-light">
                                    <th scope="row">
                                      <span className="assignedId"> {serialSequence[3]?.prefix}- {data1?.task_code} </span>{" "}
                                      <NavLink className="d-inline-block ps-2"> {data1?.task_title} </NavLink>{" "}
                                    </th>
                                    <td>
                                      <div
                                        className={
                                          "badge " +
                                          (data1?.task_status).replace(
                                            /\s/g,
                                            ""
                                          )
                                        }
                                      >
                                        {data1?.task_status}
                                      </div>
                                    </td>
                                    <HoverTooltip
                                      arrow
                                      title={
                                        data1?.task_x_owner?.length > 0
                                          ? data1?.task_x_owner
                                              .map((data) => data?.user_data?.[0]?.name)
                                              .sort((a, b) =>
                                                a.localeCompare(b)
                                              )
                                              .join(", ")
                                          : " - "
                                      }
                                    >
                                      <td
                                        style={{
                                          minWidth: "220px",
                                          maxWidth: "250px",
                                          webkitLineClamp: "3",
                                          webkitBoxOrient: "vertical",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {data1?.task_x_owner?.length > 0
                                          ? data1?.task_x_owner
                                              .map((data) => data?.user_data?.[0]?.name)
                                              .sort((a, b) =>
                                                a.localeCompare(b)
                                              )
                                              .join(", ")
                                          : " - "}
                                      </td>
                                    </HoverTooltip>
                                    <td>
                                      <div className="progressBarWrap">
                                        <div
                                          className="progress"
                                          style={{ height: "15px" }}
                                        >
                                          <div
                                            className={`progress-bar bg-success`}
                                            role="progressbar"
                                            style={{
                                              width: `${data1?.task_completion_percentage}%`,
                                            }}
                                            aria-valuenow="25"
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                          >
                                            &nbsp;
                                          </div>
                                          <div
                                            className={`percentageText ${
                                              data1?.task_completion_percentage >
                                              50
                                                ? "text-white"
                                                : ""
                                            }`}
                                          >
                                            {
                                              data1?.task_completion_percentage
                                            }
                                            %
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      {data1?.task_start_date?.length > 0
                                        ? Math.floor(
                                            (new Date(data1?.task_end_date) -
                                              new Date(
                                                data1?.task_start_date
                                              )) /
                                              (1000 * 60 * 60 * 24)
                                          ) + 1 || " 0 "
                                        : " 0 "}{" "}
                                      days
                                    </td>
                                    <td>
                                      {data1?.task_start_date?.length > 0
                                        ? new Date(
                                            data1?.task_start_date
                                          ).toLocaleDateString("en-TT")
                                        : " - "}
                                    </td>
                                    <td
                                      className={
                                        data1?.task_end_date < currentDate
                                          ? "dateExpired"
                                          : ""
                                      }
                                    >
                                      {data1?.task_end_date?.length > 0
                                        ? new Date(
                                            data1?.task_end_date
                                          ).toLocaleDateString("en-TT")
                                        : " - "}
                                    </td>
                                    <td>{data1?.task_priority}</td>
                                    <td>
                                      {data1?.task_status === "Completed"
                                        ? new Date(
                                            data1?.task_completion_date
                                          )?.toLocaleDateString("en-TT")
                                        : " -"}
                                    </td>
                                    <td>
                                      {new Date(
                                        data1?.createdDate.split(" ")?.[0]
                                      ).toLocaleDateString("en-TT")}
                                    </td>
                                    <td>
                                      {data1?.created_user?.length > 0
                                        ? data1?.created_user?.[0]?.name
                                        : "-"}
                                    </td>
                                    <td>
                                      {new Date(
                                        data1?.updatedDate.split(" ")?.[0]
                                      ).toLocaleDateString("en-TT")}
                                    </td>
                                    <td>
                                      {data1?.updated_user?.length > 0
                                        ? data1?.updated_user?.[0]?.name
                                        : "-"}
                                    </td>
                                  </tr>
                                ))}
                            </MDBTableBody>
                          </MDBTable>
                        ) : (
                          <div className="defaultPlaceholder">
                            <img
                              src={projectPlaceholderImg}
                              alt="No Project"
                            />
                            <h4 className="defaultPlaceholderText">
                              TThere are no archieve task !
                            </h4>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                ))) :
                (
                  <div className="defaultPlaceholder">
                    <img src={projectPlaceholderImg} alt="No Project" />
                    <h4 className="defaultPlaceholderText">There are no archieve task !</h4>
                  </div>
                )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ArchiveProjects;
